module.exports = __webpack_public_path__ + "images/category_lp/earphone/new/assessment_achievements/3_ebe5c581e0654c4fcc8a7be76a562f4f.png";